import React from 'react'
import { Link } from 'react-router-dom'

// "/" is served by the static animated site, which React Router does not own.
// Routing there in-app would swap to an empty view, so links that leave the SPA
// must be real navigations while the remaining routes stay client-side.
const REACT_ROUTES = ['/book', '/privacy-policy', '/cookie-policy', '/terms-of-service']

type SiteLinkProps = {
  href: string
  className?: string
  children: React.ReactNode
}

const SiteLink: React.FC<SiteLinkProps> = ({ href, className, children }) =>
  REACT_ROUTES.includes(href) ? (
    <Link to={href} className={className}>{children}</Link>
  ) : (
    <a href={href} className={className}>{children}</a>
  )

export default SiteLink
